var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page"},[(_vm.mixinBusinessNotFound || _vm.unauthorized)?_c('NotFound'):(_vm.business)?_c('ShowBusinessJoblistings',{attrs:{"business":_vm.business},on:{"unauthorized":function($event){_vm.unauthorized = true}}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }